import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zhCN from './zh-CN.json';
import enUS from './en-US.json';

Vue.use(VueI18n);

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
};

const savedLang = localStorage.getItem('app_language') || 'zh-CN';

const i18n = new VueI18n({
  locale: savedLang,
  fallbackLocale: 'zh-CN',
  messages
});

export default i18n;
